import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { Link } from '@inertiajs/react';

interface BreadcrumbItem {
    name: string;
    path: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
    return (
        <nav className="flex items-center space-x-2 text-sm">
            {items.map((item, index) => (
                <React.Fragment key={item.path}>
                    {index > 0 && (
                        <ChevronRight className="h-4 w-4 text-muted-foreground" />
                    )}
                    {index === items.length - 1 ? (
                        <span className="font-medium text-foreground flex items-center gap-2">
                            {index === 0 && <Home className="h-4 w-4" />}
                            {item.name}
                        </span>
                    ) : (
                        <Link
                            href={item.path}
                            className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                        >
                            {index === 0 && <Home className="h-4 w-4" />}
                            {item.name}
                        </Link>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
}